import { presetColors } from '@client/style/Variables';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useCurrentTime } from './utils/useCurrentTime';
import { PixelsPerHour } from './utils/PixelsPerHour';

const CurrentTimeIndicator = styled.div<{ $left: number }>`
	margin: 0px var(--gridMargin);

	position: absolute;
	top: 0;
	width: 1px;
	height: 100%;
	background-color: ${presetColors.kissMeRed};
	${props => PixelsPerHour(pph => `left: ${props.$left * pph}px;`)}
`;

export default function DateIndicator({ earliestTime }: { earliestTime: Date }) {
	const currentTime = useCurrentTime();

	const shouldShow = useMemo(() => {
		const tempDateIndicator = new Date(currentTime.getTime());
		tempDateIndicator.setHours(currentTime.getHours() - 6);

		return (
			tempDateIndicator.getFullYear() === earliestTime.getFullYear() &&
			tempDateIndicator.getMonth() === earliestTime.getMonth() &&
			tempDateIndicator.getDate() === earliestTime.getDate()
		);
	}, [currentTime]);

	const position = useMemo(() => {
		const diff = currentTime.getTime() - earliestTime.getTime();
		return diff < 0 ? 0 : diff / (1000 * 60 * 60);
	}, [earliestTime, currentTime]);

	if (!shouldShow) return <></>;

	return <CurrentTimeIndicator $left={position} />;
}
